// ets_tracing: off
import * as S from "@effect-ts/core/Collections/Immutable/Set";
import { pipe } from "@effect-ts/core/Function";
import * as Ord from "@effect-ts/core/Ord";
import * as T from "@effect-ts/core/Sync";
import { interpreter } from "../../HKT/index.mjs";
import { decoderApplyConfig, DecoderType, DecoderURI } from "../base/index.mjs";
import { appendContext, fail, makeDecoder } from "../common/index.mjs";
import { forEachArray } from "./common.mjs";
export const decoderSetInterpreter = /*#__PURE__*/interpreter()(() => ({
  _F: DecoderURI,
  set: (a, ord, eq, cfg) => env => (decoder => new DecoderType(decoderApplyConfig(cfg === null || cfg === void 0 ? void 0 : cfg.conf)(makeDecoder((u, c) => Array.isArray(u) ? T.map_(forEachArray((k, a) => decoder.validate(a, appendContext(c, String(k), decoder, a)))(u), S.fromArray(eq !== null && eq !== void 0 ? eq : Ord.getEqual(ord))) : fail(u, c, `${typeof u} is not a Set`), "set", (cfg === null || cfg === void 0 ? void 0 : cfg.name) || "Set"), env, {
    decoder
  })))(a(env).decoder)
}));
//# sourceMappingURL=set.mjs.map